import React from 'react';
import { useRef, useState, useEffect } from 'react';
import HTMLFlipBook from "react-pageflip";


export function SectionHorizontal() {
  const bookref = useRef(null);
  const sectionthreeref = useRef(null);
  const sectionisVisible = useIntersection(sectionthreeref, "0px");
  const [flipPageWidth, setFlipPageWidth] = useState(0);
  const [flipPageHeight, setFlipPageHeight] = useState(0);
  const [fontsize, setFontsize] = useState("1.7rem");

  useEffect(() => {
    if (window.innerWidth > 1024) {
      setFlipPageWidth(550);
      setFlipPageHeight(710);
    } else if (window.innerWidth > 480) {
      setFlipPageWidth(300);
      setFlipPageHeight(390);
      setFontsize("1.1rem");
    } else {
      setFlipPageWidth(170);
      setFlipPageHeight(220);
      setFontsize("0.7rem");
    }
  }, []);

  useEffect(() => {
    if (sectionisVisible) {
      const container = sectionthreeref.current;
      function handleScrollY() {
        const distance = window.scrollY - container.offsetTop;
        document.querySelector(".sectionthree").style.transform =
          `translate(0px, ${distance * (-0.8)}px)`;
      }
      document.addEventListener("scroll", handleScrollY);
      return () => document.removeEventListener("scroll", handleScrollY);
    }
  }, [sectionisVisible]);

  return (
    <>
      <div className="sectionthree" ref={sectionthreeref}>
        <div style={{ width: flipPageWidth * 2, height: flipPageHeight, fontSize: fontsize }}
          className='bookcontainer bg-primary-100 pointer-events-auto border'>
          <HTMLFlipBook
            style={{
              minHeight: 0,
              height: flipPageHeight,
            }}
            width={flipPageWidth} height={flipPageHeight}
            autoSize={false}
            size="stretch"
            flippingTime="500"
            showSwipeHint={true}
            maxShadowOpacity={1}
            ref={bookref}>

            <div className='leftContainer page-first'></div>
            <div className='rightContainer page-first'></div>

            <div className='leftContainer page-second'></div>
            <div className='rightContainer page-second'>
              <h4>Stavanger, Norway, 4 years</h4>
              <br />
              Worked for a startup company, <br />
              contributed to javascript, php, java, IOT. <br />
              <br />
              A diverse software that was, <br />
              doing things like accounting, bookings, <br />
              even managing orders of pizzas. <br />
              <br />
              Until a new adventure called, and I had to go. <br />
              It was a team of engineers, we vibed and built with care, <br />
              learned more than just the code — the craft was in the air. <br />
            </div>

            <div className='leftContainer page-third'>
              <h4>Antibes, France, 1 year</h4>
              <br /><br />There was a big company in travel industry <br />I learned more python, groovy, <br />
              but corona started, it was time to flee. <br />
            </div>
            <div className='rightContainer page-third'></div>

            <div className='leftContainer page-forth'></div>
            <div className='rightContainer page-forth'>
              <h4>Luxembourg, 1 year &amp; Zagreb, 4 years</h4>
              <br /><br />Fun it was to talk to satellites from raspberry PIs,<br />
              and to work with satellite equipment otherwise.<br /><br />
              Fun it was to work in a bank as well,<br />
              there was java spring booting,<br />
              very nice colleagues,<br />we were as close as fellowship of the ring.<br />
            </div>

            <div className='leftContainer page-fifth'><br /><h4>The End</h4></div>
            <div className='rightContainer page-fifth'></div>

          </HTMLFlipBook>
        </div>
      </div>
    </>
  );
}

export const useIntersection = (element, rootMargin) => {
  const [isVisible, setState] = useState(false);

  useEffect(() => {
    const current = element?.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setState(entry.isIntersecting);
      },
      { rootMargin }
    );
    current && observer?.observe(current);

    return () => current && observer.unobserve(current);
  }, [element, rootMargin]);

  return isVisible;
};
